/**
 * `useApiClient` — hook che costruisce un `ApiClient` collegato all'auth context.
 *
 * Allega il Bearer token corrente (`getAccessToken`) e, su risposta `401`,
 * avvia il re‑login OIDC (`login`). Le risposte `403` sono trattate come
 * accesso negato dal client stesso (vedi `client.ts`). *Validates: 4.5.*
 */
import { useMemo } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { createApiClient, type ApiClient } from './client';

export function useApiClient(): ApiClient {
  const { getAccessToken, login } = useAuth();

  return useMemo<ApiClient>(
    () =>
      createApiClient({
        getAccessToken,
        // Su 401 la sessione è assente/scaduta: avvia il flusso OIDC di re‑login.
        onUnauthenticated: () => {
          void login();
        },
      }),
    [getAccessToken, login],
  );
}
